export function isDefined<T>(x: T | undefined | null): x is T {
  return x != null;
}

const ELLIPSIS = "…";

/** @lintignore */
export function isLongerThanCharLimit(text: string, limit: number): boolean {
  return text.length > limit;
}

/** @lintignore */
export function limitTextByChar(text: string, limit: number): string {
  if (isLongerThanCharLimit(text, limit)) {
    return `${text.slice(0, limit)}${ELLIPSIS} `;
  }

  return text;
}

/** @lintignore */
export function isLongerThanWordLimit(text: string, limit: number): boolean {
  return text.split(" ").length > limit;
}

/** @lintignore */
export function limitTextByWord(text: string, limit: number): string {
  return `${text.split(" ").splice(0, limit).join(" ")}${ELLIPSIS} `;
}

export function parseAsNumber(value: string | undefined): number | undefined {
  if (value == null) {
    return undefined;
  }

  const result = Number(value);

  return isNaN(result) ? undefined : result;
}

export function sortAlphabetically<T extends { name: string }>(a: T, b: T): number {
  const aName = a.name.toLowerCase();
  const bName = b.name.toLowerCase();

  if (aName < bName) {
    return -1;
  } else if (aName > bName) {
    return 1;
  }

  return 0;
}

/**
 * Formats a locale-aware change with an explicit positive or negative sign and
 * at most one decimal place. Values that round to zero render without a sign.
 */
export function formatSignedChange(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 1,
    signDisplay: "exceptZero",
  }).format(value);
}
